import React from 'react'
import AppHeaderComponent from '../../@b_components/app_header/app_header.component'

const HeaderTemplate = function () {
  return <AppHeaderComponent />
}

export default HeaderTemplate
